/**@type {{ _uid__: number }} */
const lastIds = {};

/**
 * @param {string} [prefix="_uid__"]
 */
export function randomId(prefix = "_uid__") {
  if (!Object.prototype.hasOwnProperty.call(lastIds, prefix)) {
    lastIds[prefix] = 0;
  }

  lastIds[prefix]++;

  return `${prefix}${lastIds[prefix]}`;
}
